'use strict';

import BiBaseDataItem from './bi-base-item';

export const EVID = 17;
/**
 * Represents the "load finished" bi event:
 * http://bo.wix.com/bi-catalog-webapp/#/sources/72/events/11
 *
 * It should be used to monitor the initial application load.
 */
export default class BiErrorItem extends BiBaseDataItem {
  constructor(sessionId) {
    super(EVID, sessionId);
  }
}



// WEBPACK FOOTER //
// ./data-items/bi-error-item.js